import React from "react";
import Select from "react-select";
import { useQuery } from "react-query";
import { useAuth } from "../../hooks/useAuth";
import { Col, Row } from "react-bootstrap";
import { warehouseCategoryLabel } from "../../utils/helpers";

const WarehousePicker = ({
  value,
  onChange,
  placeholder = "Select Warehouse...",
  ...props
}) => {
  const { backendUrl } = useAuth();

  const { data: warehouses, isLoading, error } = useQuery(
    ["WAREHOUSES_LIST"],
    async () => {
      const response = await fetch(`${backendUrl}/api/warehouse`);
      if (!response.ok) {
        throw new Error("Failed to fetch warehouses");
      }
      const { warehouses } = await response.json();
      return warehouses;
    },
    {
      enabled: true,
      staleTime: 0,
    }
  );

  const options = [
    {
      W_ID: "",
      W_name: "Sales Inventory",
      W_Category: "",
      Warehouse_Type: "",
      value: "",
      label: "Sales Inventory",
    },
    ...((Array.isArray(warehouses) &&
      warehouses?.map(warehouse => ({
        ...warehouse,
        value: warehouse.W_ID,
        label: `${warehouse.W_name} | ${warehouseCategoryLabel(
          warehouse.W_Category
        )} | ${warehouse.Warehouse_Type}`,
      }))) ||
      []),
  ];

  // Find the selected option to get the proper label
  const selectedOption = options.find(option => option.value === value) || null;

  return (
    <Select
      value={selectedOption}
      onChange={onChange}
      options={options}
      isLoading={isLoading}
      isDisabled={isLoading}
      placeholder={placeholder}
      isClearable
      isSearchable
      loadingMessage={() => "Loading warehouses..."}
      noOptionsMessage={() =>
        error ? "Error loading warehouses" : "No warehouses found"
      }
      classNamePrefix="form-select"
      formatOptionLabel={el => (
        <div>
          {el?.W_name === "Sales Inventory" ? (
            <div>{el?.W_name}</div>
          ) : (
            <div className="d-flex align-items-center gap-2">
              <span>{el?.W_name}</span> <span>|</span>
              <small>{warehouseCategoryLabel(el?.W_Category)}</small>
              <span>|</span>
              <small>{el?.Warehouse_Type}</small>
            </div>
          )}
        </div>
      )}
      {...props}
    />
  );
};

export default WarehousePicker;
